import { defineComponent } from "vue";
export default defineComponent({
    props: {
        height: { type: [String, Number], required: false, default: "40px" },
        width: { type: [String, Number], required: false, default: "40px" },
        borderWidth: { type: [String, Number], required: false, default: "8px" },
        customClass: { type: String, required: false, default: "" }
    }
});
